/**
 * Header — 인증이지 헤더 (new design)
 *
 * preview/index.html 의 .header 1:1 매칭
 *  - 흰색 배경 / 좌측 로고 이미지 / 우측 4개 nav + B2B 버튼
 *  - 1023px 이하: 햄버거 메뉴로 전환
 *
 * 사용처: Home.tsx 만. 어드민에서는 사용되지 않음.
 */
import { useEffect, useState } from 'react';

export interface HeaderProps {
  /** 'B2B 접수' 버튼 클릭 → 모달 열기 */
  onOpenB2B: () => void;
}

/** 앵커 링크 정의 — 섹션 id와 정확히 일치해야 함 */
const NAV_LINKS = [
  { href: '#services', label: '서비스' },
  { href: '#benefits', label: '혜택' },
  { href: '#faq', label: 'FAQ' },
  { href: '#contact', label: '상담 신청' },
] as const;

export function Header({ onOpenB2B }: HeaderProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  // 라우트 이동/리사이즈 시 모바일 메뉴 자동 닫힘
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth >= 1024) setMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // 앵커 링크 클릭 시 모바일 메뉴 닫고 스무스 스크롤은 CSS가 처리
  const closeMobile = () => setMobileOpen(false);

  const handleB2B = () => {
    setMobileOpen(false);
    onOpenB2B();
  };

  return (
    <header className="hdr">
      <a href="#" className="hdr-logo-link" aria-label="인증이지 홈으로">
        <img className="hdr-logo" src="/logo.png" alt="인증이지 CERT EASY" />
      </a>

      {/* 데스크톱 nav */}
      <nav className="hdr-nav" aria-label="주 메뉴">
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href}>{link.label}</a>
        ))}
        <button
          type="button"
          className="btn-b2b"
          aria-label="B2B 접수 모달 열기"
          onClick={handleB2B}
        >
          B2B 접수
        </button>
      </nav>

      {/* 모바일 햄버거 버튼 */}
      <button
        type="button"
        className="hdr-menu-btn"
        aria-label="메뉴 열기"
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>

      {/* 모바일 nav (햄버거 클릭 시 열림) */}
      <div className={`hdr-mobile${mobileOpen ? ' open' : ''}`}>
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMobile}>{link.label}</a>
        ))}
        <button type="button" className="btn-b2b" onClick={handleB2B}>
          B2B 접수
        </button>
      </div>
    </header>
  );
}
